import { render, staticRenderFns } from "./NavLeft.vue?vue&type=template&id=130c9a28&scoped=true&"
import script from "./NavLeft.vue?vue&type=script&lang=js&"
export * from "./NavLeft.vue?vue&type=script&lang=js&"
import style0 from "./NavLeft.vue?vue&type=style&index=0&id=130c9a28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130c9a28",
  null
  
)

export default component.exports